export const theme = {
  colors: {
    primary: {
      white: "#FFFFFF",
      green: "#0b4f94",
      dark: "#34313F",
      grey: "#F4F4F4",
      grey100: "#C6C6C6",
      red: "#FD6E6E",
      grey200: "#F5F5F5",
      textGrey: "#666666",
      textBlack: "#333333",
      dimGrey: "#707070",
    },
    basics: {
      mostBlack: "#3B3B3B",
      black: "#000"
    },
  },
  fontWeight: {
    black: 900,
    bold: 700,
    semibold: 600,
    regular: 400,
    extraLight: 200,
  },
};
